import styles from './style.postcss';

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import is from 'is_js';
import { connect, HorizontalSelect, StudentCard } from 'omni-common-ui';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as UiState } from 'data/UiState';

class StudentSelect extends PureComponent {
  constructor(props) {
    super(props);
    this._getLinkHrefForValue = (studentId) =>
      this.props.buildRoute({ studentId, mode: '' });
  }


  componentWillMount() {
    this._buildStudentSelectOptions();
  }

  componentWillReceiveProps(nextProps) {
    this._buildStudentSelectOptions(nextProps);
  }

  _buildStudentSelectOptions(props = this.props) {
    // cache the result
    if (is.existy(this._studentSelectOptions) &&
      is.existy(this._members) &&
      this._members === props.members) {
      return;
    }
    const { members } = props;
    if (members && members.size > 0) {
      // cache this - do not recreate each time
      this._members = members;
      this._studentSelectOptions = members.map((option) => {
        const { studentGeneralInfo } = option;
        const optionHtml = <StudentCard vertical
            borderless
            backgroundless>
          <StudentCard.Profile name={studentGeneralInfo.firstName}
              surname={studentGeneralInfo.lastName}
              localName={studentGeneralInfo.localName}
              avatarUrl={studentGeneralInfo.avatarUrl}
              gender={studentGeneralInfo.gender} />
        </StudentCard>;
        return {
          html: optionHtml,
          value: studentGeneralInfo.id,
        };
      });
    }
  }

  render() {
    const { currentMember, members, isHide } = this.props;
    if (currentMember && members.size && members.size > 0) {
      return <div className={styles.StudentSelect}>
        <HorizontalSelect options={this._studentSelectOptions}
            value={currentMember && currentMember.studentGeneralInfo.id}
            getLinkHrefForValue={this._getLinkHrefForValue}
            isHide={isHide} />
      </div>;
    }
    return null;
  }
}

function mapStateToProps(state, ownProps) {
  const { studentId, groupId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  return {
    currentMember: GroupMembers.getMemberById(state, studentId),
    members,
    isHide: ! UiState.getShowNavigationBar(state),
  };
}

StudentSelect.propTypes = {
  currentMember: PropTypes.object,
  members: PropTypes.object,
  buildRoute: PropTypes.func,
  isHide: PropTypes.bool,
};

export default connect(mapStateToProps, null)(StudentSelect);



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/StudentWritingAssignment/StudentSelect/index.jsx